import * as Yup from 'yup';
import { ClientLegalStatus } from 'src/utils/constants/clients';

export default Yup.object().shape({
  legalStatus: Yup.string()
    .oneOf(Object.values(ClientLegalStatus))
    .required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  description: Yup.string()
    .trim()
    .required('SCHEMA_ERRORS.REQUIRED_FIELD')
    .max(255)
});
